import React, { useState } from "react";
import { toast } from "react-toastify";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";

// import JS files
import OrderDetails from "./OrderDetails";
import PanelTable from "../../../shares/PanelTable";
import useFetch from "../../../../context/useFetch";
import {
  fixNumbers,
  // ringTableItems,
  // ringTableItemsDataKey,
} from "../../../../utils";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTemplate from "../../../shares/PanelTemplate";
import { useSetting } from "../../../../context/SettingContext";
import set from "date-fns-jalali/set/index.js";

const mobileHeadersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "النگو" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "created_at", name: "تاریخ ثبت‌سفارش" },
];

const Stock = () => {
  const [codeFilter, setCodeFilter] = useState(null);
  const [brandFilter, setBrandFilter] = useState(null);
  const [colorFilter, setColorFilter] = useState(null);
  const { ringTableItems, ringTableItemsDataKey } = useSetting();
  const [nameFilter, setNameFilter] = useState(null);
  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });
  const [brandsList, setBrandsList] = useState({ results: [] });

  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",

    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const ColorItemList = [
    {
      name: "زرد",
      value: "yellow",
    },
    {
      name: "سفید",
      value: "white",
    },
  ];
  const filterList = [
    {
      type: "textField",
      label_fa: "کد",
      label_en: "code",
      state: codeFilter,
      isLTR: true,
    },
    {
      type: "select",
      label_fa: "برند",
      label_en: "brand",
      state: brandFilter,
      menuItems: brandsList.results,
      fromApi: true,
    },
    {
      type: "select",
      label_fa: "رنگ",
      label_en: "color",
      state: colorFilter,
      menuItems: ColorItemList,
      fromApi: false,
    },
    {
      type: "textField",
      label_fa: "نام النگو",
      label_en: "name",
      state: nameFilter,
    },
  ];
  const update_filter = (state, e) => {
    if (state == "brand") setBrandFilter(e);
    if (state == "color") setColorFilter(e);
    if (state == "name") setNameFilter(e.length > 0 ? e : null);

    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
  };

  const filter = () => {
    if (
      codeFilter !== null ||
      nameFilter !== null ||
      brandFilter !== null ||
      colorFilter !== null
    ) {
      setRequestList({ results: [] });
      getRequestListApi.reFetch();
    }
  };

  const reset_filter = () => {
    setRequestList({ results: [] });
    setNameFilter(null);

    setBrandFilter(null);
    setColorFilter(null);
    setCodeFilter(null);
    getRequestListApi.reFetch();
  };

  const buttonsList = [
    {
      label: "مشاهده جزییات",
      component: (it) => (
        <OrderDetails selectedRow={it} getRequestListApi={getRequestListApi} />
      ),
    },
  ];

  const actionsList = [];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 350,
    count: 0,
  });

  const [requestList, setRequestList] = useState({ results: [] });

  const getRequestListApi = useFetch({
    method: "get",
    params: {
      brand: brandFilter,
      code: fixNumbers(codeFilter),
      name: nameFilter,
      color: colorFilter,
      show_changed: true,
    },
    url: "BangleStock_Service",
    trigger: true,
    pagination: paginationPageInfo,
    setter: setRequestList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });


  return (
    <>
      <PanelTemplate sidebarActiveLink="stocks">
        <>
          <div className="panel-main-header">
            <span>ثبت موجودی</span>
          </div>
          <PanelFilter
            header="فیلتر :"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <PanelTable
            header="لیست النگوهای قابل ثبت سفارش:"
            headers={ringTableItems()}
            dataKey={ringTableItemsDataKey()}
            mobileHeaders={mobileHeadersList}
            data={requestList.results}
            buttons={buttonsList}
            actions={actionsList}
            icon={<AddShoppingCartIcon />}
            // setSelectedRow={setSelectedRow}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default Stock;
